<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a Location"
    size="lg"
    @on-hide="resetFormData"
  >
    <locations-form
      :client_ids="client_ids"
      @on-submit="createLocation"
      @on-save="redirectToLocation"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import LocationsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'LocationsAddModal',
  mixins: [formModalMixin],
  props: {
    client_ids: {
      type: Array,
    },
  },
  components: {
    LocationsForm,
  },
  data() {
    return {
      modalId: 'location-add-modal',
    };
  },
  methods: {
    createLocation(data, handleCreate) {
      if (!this.$store.getters.isBMSOrganization) {
        handleCreate(this.$locationsAPI.create(data));
        return;
      }

      const { netsuite_project_id, ...locationData } = data;
      const request = this.$locationsAPI.create(locationData).then((location) => {
        if (!netsuite_project_id) {
          return location;
        }

        return this.$integrationReferencesAPI
          .createNetSuiteReference({
            reference_id: location.id,
            reference_type: 'Location',
            source_id: netsuite_project_id,
          })
          .then(() => location)
          .catch(() => {
            if (this.$bvToast) {
              this.$bvToast.toast('Location created, but the NetSuite project connection failed. Please connect it from the location page.', {
                title: 'NetSuite project not connected',
                toaster: 'b-toaster-bottom-right',
                variant: 'warning',
                autoHideDelay: 6000,
                appendToast: false,
              });
            }
            return location;
          });
      });

      handleCreate(request);
    },
    redirectToLocation(location) {
      this.$router.push({ name: 'location', params: { id: location.id } });
    },
  },
};
</script>
